module.exports = __webpack_public_path__ + "static/media/external-link.17ae429b.svg";